var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('v-progress-linear',{staticClass:"mt-2",attrs:{"indeterminate":"","color":"red"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }